import type { RouteRecordRaw } from 'vue-router';

import PersonalSettingsLayout from './views/layouts/PersonalSettingsLayout/PersonalSettingsLayout.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/personal-settings',
    component: PersonalSettingsLayout,
    children: [
      {
        path: 'profile',
        name: 'personal-settings.profile',
        component: () => import('./views/pages/PersonalSettingsProfilePage.vue'),
        meta: {
          title: 'Persoonlijke instellingen',
        },
      },
      {
        path: 'security',
        name: 'personal-settings.security',
        component: () => import('./views/pages/PersonalSettingsSecurityPage.vue'),
        meta: {
          title: 'Persoonlijke instellingen',
        },
      },
      {
        path: 'terms',
        name: 'personal-settings.terms',
        component: () => import('./views/pages/PersonalSettingsTermsPage.vue'),
        meta: {
          title: 'Persoonlijke instellingen',
        },
      },
      {
        path: '',
        redirect: { name: 'personal-settings.profile' },
      },
    ],
  },
];
